import assign from "lodash/fp/assign";
import apis from "../../core/apis.js";

class RouteResource {
  constructor($resource) {
    "ngInject";

    this.$resource = $resource;
  }

  getAll(options) {
    return this.$resource(apis.route).get(options);
  }

  get(id) {
    return this.$resource(apis.route + id).get();
  }

  search(query = "", params) {
    return this.$resource(apis.route + "autocomplete/").get(
      assign(params, { query })
    );
  }

  post(item) {
    return this.$resource(apis.route).save(item);
  }

  update(id, item) {
    return this.$resource(apis.route + id, null, {
      update: { method: "PATCH" },
    }).update(item);
  }

  reflectDetails(id, item) {
    return this.$resource(apis.route + id + "/reflect").save(item);
  }

  dispatch(id, item) {
    return this.$resource(apis.route + id + "/dispatch").save(item);
  }

  updateAction(id, name, item) {
    return this.$resource(apis.route + id + `/${name}`).save(item);
  }
}

export default RouteResource;



// WEBPACK FOOTER //
// ./src/resources/route/route.resource.js